import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const DASHBOARD_TYPOGRAPHY = {
  sectionTitle: "text-xs font-semibold uppercase tracking-[0.18em] text-white/65",
  body: "text-sm font-medium text-white",
  value: "text-2xl font-semibold tracking-tight text-white",
  meta: "text-sm text-white/55",
};
